"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputCheckbox_styles_1 = __importDefault(require("./InputCheckbox.styles"));
var InputCheckbox = function (_a) {
    var label = _a.label, id = _a.id, _b = _a.checked, checked = _b === void 0 ? false : _b, valueChanged = _a.valueChanged, _c = _a.buttonStyle, buttonStyle = _c === void 0 ? false : _c;
    return (react_1.default.createElement(InputCheckbox_styles_1.default, { checked: checked, buttonStyle: buttonStyle },
        react_1.default.createElement("input", { type: "checkbox", id: id, name: id, checked: checked, onChange: function () {
                if (valueChanged)
                    valueChanged();
            } }),
        react_1.default.createElement("label", { htmlFor: id }, label)));
};
exports.default = InputCheckbox;
